import {createApp} from 'vue'
import App from './App.vue'
import './assets/styles/main.css'
import LoggingPlugin, {setLogLevel} from './services/logging';
import {loggingInfo, params} from './systemInfo';
import {registerSW} from 'virtual:pwa-register'
import {updateRebootDate} from "@/services/reboot.js";
import {showNotification} from "@/services/notification.js";
import {setRes} from "./services/google/chrome.js";
import {installDiagnostics} from "@/services/diagnostics.js";

// Admin mode
(function () {
    initApp()

    if (import.meta.env.VITE_ENVIRONMENT !== 'prd') return;

    const headerElem = document.getElementById('header-icon');
    const SECRET = import.meta.env.VITE_DEV_SECRET?.split(',')
    const RESET = {ctrlKey: true, key: import.meta.env.VITE_DEV_RESET};

    // STATE
    let pos = 0;
    let armed = false; // true = shortcuts are now allowed

    // LIST OF HOTKEYS TO BLOCK - MacOS and others included for testing
    const blocked = [
        {key: 'F12'},
        {ctrlKey: true, shiftKey: true, key: 'I'},
        {ctrlKey: true, shiftKey: true, key: 'J'},
        {ctrlKey: true, shiftKey: true, key: 'C'},
        {ctrlKey: true, key: 'U'},                  // view-source
        {metaKey: true, shiftKey: true, key: 'I'},  // macOS
        {metaKey: true, shiftKey: true, key: 'J'},  // macOS
        {metaKey: true, shiftKey: true, key: 'C'},  // macOS
        {metaKey: true, key: 'U'}                   // macOS view-source
    ];

    // MATCH HELPER
    const matches = (ev, def) =>
        def.key === ev.key &&
        !!def.ctrlKey === ev.ctrlKey &&
        !!def.shiftKey === ev.shiftKey &&
        !!def.metaKey === ev.metaKey;

    // KEYBOARD HANDLER
    document.addEventListener('keydown', e => {
        // RESET
        if (e.key === RESET.key) {
            e.preventDefault();
            armed = false;
            setLogLevel(import.meta.env.VITE_LOG_LEVEL)
            pos = 0;
            console.warn('[DevTools] Shortcuts re-blocked.');
            headerElem.style.borderColor = 'var(--color-primary-light)';
            console.info('[DevTools] Shortcuts LOCKED.');
            showNotification(`Buzztime Admin Mode Disabled`, '', false, true);
            setLogLevel('info');
            return;
        }

        // SECRET SEQUENCE
        if (!armed) {
            if (e.key === SECRET[pos]) {
                pos++;
                if (pos === SECRET.length) {
                    armed = true;
                    setLogLevel('debug')
                    pos = 0;
                    console.info('[DevTools] Shortcuts UNLOCKED.');
                    showNotification(`Buzztime Admin Mode Enabled`, '', false, true);
                    headerElem.style.borderColor = 'var(--color-secondary)';
                }
                e.preventDefault(); // swallow the secret keys themselves
                return;
            } else {
                pos = 0; // typo → restart sequence
            }
        }

        // BLOCK DEVTOOLS SHORTCUTS WHEN NOT ARMED
        if (!armed && blocked.some(b => matches(e, b))) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    });

    console.info('[DevTools] Shortcuts BLOCKED. Enter secret keychain.');
})();

function initApp() {
    // registerSW()

    const updateSW = registerSW({
        // immediate: true, // Register immediately
        // onNeedRefresh() {
        //     console.log('New content available!');
        //     // Automatically update
        //     updateSW();
        // },
        // onOfflineReady() {
        //     console.log('App ready for offline use');
        // },
        // onRegistered(registration) {
        //     console.log('Service worker registered:', registration);
        // },
        // onRegisterError(error) {
        //     console.error('Service worker registration error:', error);
        // }
    });

    // Check for required environment variables
    const requiredEnvVars = [
        'VITE_CLOUDHUB_BASE_URL',
        'VITE_HANDSHAKE_JWT_KEY',
        'VITE_R7_KEY',
        'VITE_R7_REG'
    ];

    const missingEnvVars = requiredEnvVars.filter(
        varName => !import.meta.env[varName]
    );

    if (missingEnvVars.length > 0) {
        console.error(
            `Missing required environment variables: ${missingEnvVars.join(', ')}`
        );
    }

    // Create and mount the Vue app
    const app = createApp(App);

    installDiagnostics(app);

    // Initialize logging
    app.use(LoggingPlugin, {
        token: import.meta.env.VITE_R7_KEY,
        region: import.meta.env.VITE_R7_REG,
        siteInfo: loggingInfo
    });

    setRes()

    updateRebootDate(true)

    // Set background video with version parameter to prevent caching
    const bgVideo = document.querySelector(".background-video");
    if (bgVideo) {
        bgVideo.src = `/backgrounds/${params.backgroundSrc}`;
    }

    app.mount('#app');
}